<template>
	<JBox class="s-w-full s-bg-gray-100 s-min-h-screen">
		<JBox class="s-w-ful s-pt-12 s-max-w-3xl s-m-auto">
			<!-- Locales -->
			<JFlex class="s-justify-end s-items-center s-mb-1">
				<JSpinner v-if="isLoading" class="s-mr-3" type="dots" />
				<JBox class="s-w-32">
					<JSelect
						:allowSelectNothing="false"
						:value="locale"
						@input="handleChangeLocale"
						:options="$store.state.settings.localesDictionary"
					/>
				</JBox>
			</JFlex>

			<!-- Info -->
			<ProductInfo>
				<JFlex class="s-w-full s-justify-between s-p-8 sm:s-border-t sm:s-border-gray-200">
					<JButton @click="showUpdateModal = true" variant="default-light">
						{{ $t("products.update") }}
					</JButton>
				</JFlex>
			</ProductInfo>

			<!-- Update modal -->
			<Portal to="layer0">
				<CModal :isVisible="showUpdateModal">
					<ProductUpdateForm @save="handleUpdate" @cancel="showUpdateModal = false" />
					<JFlex class="s-justify-center">
						<JSpinner v-if="isLoading" class="s-mt-2 s-mb-6" type="dots" />
					</JFlex>
				</CModal>
			</Portal>

			<Portal to="layer1">
				<CMessage />
			</Portal>
		</JBox>
	</JBox>
</template>

<script>
import ProductInfo from "../components/ProductInfo"
import ProductUpdateForm from "../components/ProductUpdateForm"

export default {
	components: { ProductInfo, ProductUpdateForm },

	// From router
	props: ["productType", "productPlan", "productVersion"],

	data() {
		return {
			showUpdateModal: false,
			isLoading: false
		}
	},

	computed: {
		locale() {
			return this.$store.state?.products?.detail?.locale ?? this.$store.getters.locale
		}
	},

	methods: {
		async fetchProduct() {
			this.isLoading = true
			await this.$store.dispatch("products/fetchProduct", {
				productId: {
					type: this.productType,
					plan: this.productPlan,
					version: this.productVersion
				},
				locale: this.locale
			})
			this.isLoading = false

			// TODO: check errors, display error message if fetching failed
		},

		handleChangeLocale(locale) {
			this.$store.dispatch("products/setProperty", { path: "detail.locale", value: locale })
			this.fetchProduct()
		},

		async handleUpdate({ name, insurerId }) {
			if (this.isLoading) return
			const locale = this.locale

			this.isLoading = true
			const { isSuccess, res } = await this.$store.dispatch("products/updateProduct", {
				name,
				plan: this.productPlan,
				type: this.productType,
				insurerId,
				version: this.productVersion,
				locale
			})
			this.isLoading = false

			// Handle errors
			if (!isSuccess) {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: res?.data?.upsertL10n?.errors?.[0] ?? this.$t("global.errors.general") }
				})

				return
			}

			this.showUpdateModal = false
		}
	},

	watch: {
		locale: {
			handler() {
				this.fetchProduct()
			},
			immediate: true
		}
	}
}
</script>
